import { useMutation } from '@hooks/reactQuery';

import { deleteAlarmNoVesRules } from '@api/alarmManagement';

import { IId } from '@interfaces/common/common';

import { ALARM_DELETE_NO_VES_RULE_ORAN } from '@constants/queryKeys';

interface IUseMutateAlarmsDeleteNoVesRulesReturn {
	deleteAlarmNoVesRules: (data: IId[]) => void;
	isLoadingDeleteAlarmNoVesRules: boolean;
}

export const useMutateAlarmsDeleteNoVesRules = (): IUseMutateAlarmsDeleteNoVesRulesReturn => {
	const {
		mutateAsync,
		isLoading,
	} = useMutation<IId[]>({
		mutationKey: [ALARM_DELETE_NO_VES_RULE_ORAN],
		mutationFn: deleteAlarmNoVesRules,
	});

	return {
		deleteAlarmNoVesRules: mutateAsync,
		isLoadingDeleteAlarmNoVesRules: isLoading,
	};
};
